import debounce from 'lodash/debounce';
import * as R from 'ramda';
import { WithId } from '../../../../../../../../../../types/Base.types';
import { ObjectToDebounceById } from '../types';

export class SaveEntityWithDebounceHandler<T extends WithId> {
  private debouncedSaveEntities: ObjectToDebounceById<T> = {};

  constructor(
    private delayInMilliseconds: number,
    private saveFunction: (data: T) => Promise<void>,
  ) {}

  save(entity: T) {
    if (!this.debouncedSaveEntities[entity.id]) {
      this.debouncedSaveEntities[entity.id] = debounce(async (entity: T) => {
        await this.saveFunction(entity);
        delete this.debouncedSaveEntities[entity.id];
      }, this.delayInMilliseconds);
    }
    this.debouncedSaveEntities[entity.id](entity);
  }

  hasSavedAll() {
    return R.isEmpty(this.debouncedSaveEntities);
  }
}
